import { ArrowLeftIcon } from '@/public/assets/v2/images/icons'
import {
  Drawer as DrawerMantine,
  DrawerProps as DrawerPropsMantine,
} from '@mantine/core'
import { Text } from '../commons/typography/Text'

interface DrawerProps extends DrawerPropsMantine {
  children: React.ReactNode
  withBackButton?: boolean
  colorBackButton?: string
}

export const Drawer = ({
  children,
  withBackButton,
  colorBackButton = 'text-primary',
  ...rest
}: DrawerProps) => {
  return (
    <DrawerMantine
      className="--v2"
      style={{
        zIndex: 10000015,
      }}
      styles={{
        overlay: {
          zIndex: 10000015,
        },
        inner: {
          zIndex: 10000015,
        },
        content: {
          zIndex: 10000015,
        },
      }}
      {...rest}
    >
      {withBackButton && (
        <div className="px-10 pt-10">
          <div
            className="flex items-center gap-6 cursor-pointer"
            onClick={rest.onClose}
          >
            <ArrowLeftIcon className={colorBackButton} />
            <Text variation="small" colorClass={colorBackButton}>
              Back
            </Text>
          </div>
        </div>
      )}
      {children}
    </DrawerMantine>
  )
}
